import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import permissionService from "../../services/permissionService";

// Permission Management Thunks
export const getAllAdminsWithPermissionsThunk = createAsyncThunk(
  "permission/getAllAdminsWithPermissions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await permissionService.getAllAdminsWithPermissions();
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const updateAdminPermissionsThunk = createAsyncThunk(
  "permission/updateAdminPermissions",
  async ({ adminId, permissions }, { rejectWithValue }) => {
    try {
      const response = await permissionService.updateAdminPermissions(
        adminId,
        permissions
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const applyPresetRoleThunk = createAsyncThunk(
  "permission/applyPresetRole",
  async ({ adminId, rolePreset }, { rejectWithValue }) => {
    try {
      const response = await permissionService.applyPresetRole(
        adminId,
        rolePreset
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const getPermissionTemplatesThunk = createAsyncThunk(
  "permission/getPermissionTemplates",
  async (_, { rejectWithValue }) => {
    try {
      const response = await permissionService.getPermissionTemplates();
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const checkPermissionThunk = createAsyncThunk(
  "permission/checkPermission",
  async ({ module, action, context }, { rejectWithValue }) => {
    try {
      const response = await permissionService.checkPermission(
        module,
        action,
        context
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// Approval Management Thunks
export const getPendingApprovalsThunk = createAsyncThunk(
  "permission/getPendingApprovals",
  async (_, { rejectWithValue }) => {
    try {
      const response = await permissionService.getPendingApprovals();
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const approveRequestThunk = createAsyncThunk(
  "permission/approveRequest",
  async ({ approvalId, comments }, { rejectWithValue }) => {
    try {
      const response = await permissionService.approveRequest(
        approvalId,
        comments
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const rejectRequestThunk = createAsyncThunk(
  "permission/rejectRequest",
  async ({ approvalId, reason }, { rejectWithValue }) => {
    try {
      const response = await permissionService.rejectRequest(
        approvalId,
        reason
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const getApprovalHistoryThunk = createAsyncThunk(
  "permission/getApprovalHistory",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await permissionService.getApprovalHistory(filters);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const createApprovalRequestThunk = createAsyncThunk(
  "permission/createApprovalRequest",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await permissionService.createApprovalRequest(
        requestData
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// Actions
export const clearPermissionError = createAction("permission/clearError");
export const setApprovalFilter = createAction("permission/setApprovalFilter");
export const setSelectedAdmin = createAction("permission/setSelectedAdmin");
